import React from 'react';
import Loadable from 'react-loadable';
import { Redirect, Switch } from 'react-router-dom';
import EditableRoute from '@components/EditableRoute';

import { DataCaptureRoutes } from './constants';
import DataCapturePageWrapper from './components/PageWrapper';

const Loading = () => <div />;

const DataCaptureRequests = Loadable({
  loader: () => import('./pages/requests'),
  loading: Loading,
});

const Routes = props => (
  <DataCapturePageWrapper {...props}>
    <Switch>
      <EditableRoute
        component={DataCaptureRequests}
        exact
        path={DataCaptureRoutes.DataCaptureRequests}
      />
      <Redirect to={DataCaptureRoutes.DataCaptureRequests} />
    </Switch>
  </DataCapturePageWrapper>
);

export default Routes;
